import React, {useRef, useEffect} from 'react';
import {TextInput} from 'react-native';
import {useSelector, useDispatch} from 'react-redux';
import i18n from 'i18n-js';
import scanpackStyles from '../../style/scanpack';
import {
  setInput,
  handleInput,
  setFocus
} from '../../actions/productFirstActions';
import {selectToteIdentifier} from '../../selectors/productFirstSelectors';
import {useNavigationFocus} from '../../hooks/useAutoFocus';

const ScanField = () => {
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const {input, stage, mainInputHasFocus} = useSelector(state => ({
    input: state.productFirst.input,
    stage: state.productFirst.stage,
    mainInputHasFocus: state.productFirst.mainInputHasFocus
  }));
  const toteIdentifier = useSelector(selectToteIdentifier);

  useNavigationFocus(setFocus);

  useEffect(() => {
    if (mainInputHasFocus) {
      inputRef.current?.focus();
    }
  }, [mainInputHasFocus, stage]);

  const placeholder =
    stage === 'tote'
      ? i18n.t('productFirst.scanTotePlaceholder', {toteIdentifier})
      : i18n.t('productFirst.scanProductPlaceholder');

  return (
    <TextInput
      testID="putWallScanInput"
      ref={inputRef}
      value={input}
      style={scanpackStyles.scanBarCodeInput}
      placeholder={placeholder}
      placeholderTextColor={'#acacad'}
      onChangeText={text => dispatch(setInput(text))}
      onSubmitEditing={() => dispatch(handleInput())}
      autoCapitalize="none"
      returnKeyType="done"
    />
  );
};

export default ScanField;
